import css from 'styled-jsx/css';

const styles = css.global`#renegociacao25-canais {
  padding: 40px 0 0;
  overflow: hidden;
}

#renegociacao25-canais .canais-principal {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

#renegociacao25-canais .canais-principal .canais-textos {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

#renegociacao25-canais .canais-textos .canais-titulo {
  color: #C00;
  font-family: "SantanderHeadline";
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px;
}

#renegociacao25-canais .canais-textos .canais-texto {
  color: #444;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
}

#renegociacao25-canais .canais-carrossel .slide {
  border-radius: 4px;
  background: #FFF;
  box-shadow: 0px 4px 8px 0px rgba(34, 34, 34, 0.12);
  width: 240px;
  height: 138px;
  margin-right: 24px;
  flex: 0 0 240px;
}

#renegociacao25-canais .canais-carrossel .slide-contain {
  width: 240px;
  height: 138px;
  cursor: pointer;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: relative;
}

#renegociacao25-canais .canais-carrossel .slide-contain .qrcode-whatsapp {
  position: absolute;
  width: 110px;
  right: 16px;
}

#renegociacao25-canais .canais-carrossel .canais-card-img-titulo {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
}

#renegociacao25-canais .canais-carrossel .canais-card-titulo {
  color: #444;
  font-family: "SantanderMicroText";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
}

#renegociacao25-canais .canais-carrossel .canais-card-link {
  color: #C00;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 155.556% */
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}

#renegociacao25-canais .canais-carrossel .canais-card-link.link-email {
  font-size: 16px;
}

#renegociacao25-canais .canais-carrossel .home-pagination {
  margin-top: 24px;
}

#renegociacao25-canais .home-pagination .embla__prev {
  background-image: url(assets/renegociacao25/canais/ic_arrow_l.svg);
}

#renegociacao25-canais .home-pagination .embla__next {
  background-image: url(assets/renegociacao25/canais/ic_arrow_r.svg);
}

#renegociacao25-canais .home-pagination .embla__prev, 
#renegociacao25-canais .home-pagination .embla__next {
  width: 24px;
  height: 24px;
  background-size: 24px 24px;
}

.canais-show-sms {
  /* display: none; */
  height: 0px;
  opacity: 0;
  transition: all 0.5s ease;
  position: relative;
}

.canais-show-sms.expanded {
  height: auto;
  opacity: 1;
  padding-top: 32px;
  
}

.canais-show-sms .canais-sms-imagem {
  background-image: url(assets/renegociacao25/canais/circles.svg);
  width: 195px;
  height: 101px;
  background-repeat: no-repeat;
  margin-top: 10px;
  position: absolute;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  left: -14px;
}

.canais-show-sms .canais-sms-conteudo {
  padding: 115px 16px 32px 0;
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.canais-show-sms .canais-sms-conteudo .canais-sms-textos {
  display: flex;
  flex-direction: column;
  gap: 8px;
} 

.canais-show-sms .canais-sms-textos .canais-sms-titulo {
  color: #444;
  font-family: "SantanderHeadline";
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px;
}

.canais-show-sms .canais-sms-textos .canais-sms-texto {
  color: #222;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
}

.canais-show-sms .canais-sms-textos .canais-sms-texto b {
  font-weight: 600;
}

.canais-show-sms .canais-sms-conteudo .canais-sms-dicas {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.canais-show-sms .canais-sms-dicas .canais-sms-dica {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.canais-show-sms .canais-sms-dica .canais-sms-dica-number {
  color: #C00;
  font-family: "SantanderText";
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 48px; 
}

.canais-show-sms .canais-sms-dica .canais-sms-dica-texto {
  color: #444;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
}

#renegociacao25-canais .img-separador-reneg {
  height: 320px;
  display: block;
  padding-top: 40px;
}


#renegociacao25-canais .img-separador-reneg img {
  width: 100%;
  height: 320px;
  object-fit: cover;
}

@media (min-width: 992px) {
  #renegociacao25-canais {
    padding: 40px 0 0;
    overflow: hidden;
  }

  #renegociacao25-canais .img-separador-reneg  {
    padding-top: 66px;
  }

  
  #renegociacao25-canais .home-pagination {
    display: none;
  }

  .canais-show-sms .canais-sms-imagem {
    background-image: url(assets/renegociacao25/canais/circles-desk.svg);
    width: 374px;
    height: 219px;
    margin-top: 0;
    left: initial;
    right: -143px;
    position: absolute;
    background-size: auto;
  }

  .canais-show-sms .canais-sms-imagem img {
    position: absolute;
    top: 112px;
    left: 50px;
    width: 156px;
    height: 156px;
  }
  
  .canais-show-sms .canais-sms-conteudo {
    padding: 40px 0 14px;
  }

  .canais-show-sms .canais-sms-conteudo .canais-sms-textos {
    gap: 16px;
  } 

  .canais-show-sms .canais-sms-textos .canais-sms-titulo {
    font-size: 32px;
    line-height: normal;
  }

  .canais-show-sms .canais-sms-dicas .canais-sms-dica {
    align-items: flex-end;
    height: 48px;
  }

  .canais-show-sms .canais-sms-dica .canais-sms-dica-number {
    line-height: 38px;
  }
}`;

export default styles;